import React from "react";

interface IBookmarkIconProps extends React.SVGProps<any> {
  viewerDidBookmark?: boolean;
  bookmarkedColor?: string;
  notBookmarkedColor?: string;
  borderColor?: string;
}

export default function BookmarkIcon({
  viewerDidBookmark = false,
  bookmarkedColor = "#28D094",
  notBookmarkedColor = "none",
  borderColor = "#3F4A5A",
  ...props
}: IBookmarkIconProps) {
  return (
    <svg width="13" height="20" viewBox="0 0 13 20" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.9445 2.05874C2.30562 2.05874 1.82339 2.55742 1.82339 3.12222V17.1728L6.59853 12.5483L11.3736 17.1735V3.12222C11.3736 2.55795 10.8912 2.05874 10.2525 2.05874H2.9445ZM0.411621 3.12222C0.411621 1.73505 1.5693 0.646973 2.9445 0.646973H10.2525C11.6279 0.646973 12.7854 1.73594 12.7854 3.12222V17.9849C12.7854 18.5913 12.2842 19.0446 11.7141 19.0446H11.713C11.4375 19.0442 11.1689 18.9388 10.9666 18.7447L10.9643 18.7424L6.59845 14.5137L2.23437 18.7401C2.2341 18.7404 2.23383 18.7406 2.23355 18.7409C1.92612 19.04 1.47166 19.1241 1.08007 18.9661C0.685916 18.8083 0.411499 18.4267 0.411621 17.9848V3.12222Z"
        fill={viewerDidBookmark ? bookmarkedColor : borderColor}
      />
      <path
        d="M2.9445 2.05874C2.30562 2.05874 1.82339 2.55742 1.82339 3.12222V17.1728L6.59853 12.5483L11.3736 17.1735V3.12222C11.3736 2.55795 10.8912 2.05874 10.2525 2.05874H2.9445Z"
        fill={viewerDidBookmark ? bookmarkedColor : notBookmarkedColor}
      />
    </svg>
  );
}
